import { useIsTabletOrLarger } from '../../responsive/hooks/hooks';
import { GrowegyMenu } from '../../commons/components/GrowegyMenu';
import React, { ReactElement, useState } from 'react';
import { createTutorialsMenuItem } from './TutorialMenuItem';
import { createReleasesMenuItem } from './ReleaseMenuItem';
import { createSupportMenuItem } from './SupportMenuItem';
import { createAppStoreMenuItem } from './AppStoreMenuItem';
import { createPlayStoreMenuItem } from './PlayStoreMenuItem';
import { v4 as uuidv4 } from 'uuid';
import { DownloadAppModal } from './DownloadAppModal';

export const HelpMenu = (props: { customToggle?: () => ReactElement }) => {
  const { customToggle } = props;
  const isTabletOrLarger = useIsTabletOrLarger();
  const [downloadOnAppStoreKey, setDownloadOnAppStoreKey] = useState<string | null>(null);
  const [getOnPlayStoreKey, setGetOnPlayStoreKey] = useState<string | null>(null);

  return (
    <>
      <GrowegyMenu
        menuItems={[
          createTutorialsMenuItem(false, 'app-sidebar__help-tutorials'),
          createReleasesMenuItem(false, 'app-sidebar__help-releases'),
          createSupportMenuItem(false, 'app-sidebar__help-support'),
          {
            type: 'divider',
            dataTest: 'app-sidebar__help-divider-tutorials',
          },
          createAppStoreMenuItem(
            false,
            () => {
              setDownloadOnAppStoreKey(uuidv4());
              setGetOnPlayStoreKey(null);
            },
            'app-sidebar__help-app-store'
          ),
          createPlayStoreMenuItem(
            false,
            () => {
              setDownloadOnAppStoreKey(null);
              setGetOnPlayStoreKey(uuidv4());
            },
            'app-sidebar__help-play-store'
          ),
        ]}
        menuButtonDataTest="help-menu__link-button"
        containerDataTest="help-menu__link"
        containerClassName="help-menu__link--help"
        drop={isTabletOrLarger ? 'right' : 'up'}
        positionStrategy="fixed"
        customToggle={customToggle}
      />
      {downloadOnAppStoreKey && <DownloadAppModal store="app-store" key={downloadOnAppStoreKey} />}
      {getOnPlayStoreKey && <DownloadAppModal store="play-store" key={getOnPlayStoreKey} />}
    </>
  );
};
